/* eslint-disable react/jsx-filename-extension */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import AddRoom from '../addRooms';
import {
  currentRowSelector,
} from '../../selectors/roomMeasure';
import { useEditModal } from '../roomCardModel/useEditModal';

export function UpdateRoom({
  isOpen,
  roomName,
  roomLength,
  roomWidth,
  UpdatedLengthPlaceHolder,
  updatedWidthPlaceHolder,
  updatedNamePlaceholder,
  onHandleClose,
}) {
  const editableRow = useSelector(currentRowSelector) || [];
  const [newRoom, setNewRoom] = useState(editableRow);
  useEditModal(
    isOpen,
    editableRow[0].room,
    editableRow[0].length,
    editableRow[0].width,
  );

  useEffect(() => {
    const currentRoom = {
      id: editableRow[0].id,
      room: editableRow[0].room,
      length: editableRow[0].length,
      width: editableRow[0].width,
    };
    setNewRoom(currentRoom);
  }, [isOpen]);

  return (
    <>
      {isOpen ? (
        <AddRoom
          updatedMeasure={newRoom}
          isEdit={isOpen}
          showModal={isOpen}
          roomName={roomName}
          roomLength={roomLength}
          roomWidth={roomWidth}
          roomLengthPlaceholder={UpdatedLengthPlaceHolder}
          roomWidthPlaceholder={updatedWidthPlaceHolder}
          roomNamePlaceholder={updatedNamePlaceholder}
          handleClose={onHandleClose}
        />
      )
        : null}
    </>
  );
}

UpdateRoom.propTypes = {
  isOpen: PropTypes.bool,
  roomName: PropTypes.string.isRequired,
  roomLength: PropTypes.string.isRequired,
  roomWidth: PropTypes.string.isRequired,
  UpdatedLengthPlaceHolder: PropTypes.string.isRequired,
  updatedWidthPlaceHolder: PropTypes.string.isRequired,
  updatedNamePlaceholder: PropTypes.string.isRequired,
  onHandleClose: PropTypes.func.isRequired,
};

UpdateRoom.defaultProps = {
  isOpen: false,
};
